import { useEffect, useState } from "react";
import FileRecord from "models/view-models/file-record";
import RemoteAccessDetailsService from "utilities/services/remote-access-details-service";
import SharedPageRemoteAccessDetailsService from "utilities/services/public/pages/shared-page-remote-access-details-service";

export const useImageFilePath = (
    imageFile?: FileRecord,
    pageGuid?: string,
    recipientGuid?: string
) => {
    const [imageFilePath, setImageFilePath] = useState<string>("");

    useEffect(() => {
        if (imageFile == null) return;

        (async () => {
            const remoteAccessDetailsResult = pageGuid
                ? await SharedPageRemoteAccessDetailsService.get(
                      {
                          pageGuid,
                      },
                      {
                          recipientGuid,
                          storageContainer: imageFile.storageContainer,
                          relativeProviderPath: imageFile.relativeProviderPath,
                      }
                  )
                : await RemoteAccessDetailsService.get(undefined, {
                      storageContainer: imageFile.storageContainer,
                      relativeProviderPath: imageFile.relativeProviderPath,
                  });

            setImageFilePath(remoteAccessDetailsResult.resultObject?.url ?? "");
        })();
    }, [imageFile, pageGuid, recipientGuid]);

    return imageFilePath;
};
